import Joi from "joi";

const CityMasterSchema = Joi.object({
  cityName: Joi.string().trim().required().messages({
    "string.empty": "City Name is required.",
  }),
  state: Joi.string().trim().required().messages({
    "string.empty": "State Name is required.",
  }),
  country: Joi.string().trim().required().messages({
    "string.empty": "Country is required.",
  }),
}).unknown(true);

export default CityMasterSchema;
